import { gsap } from 'gsap';
import gsapCore from 'gsap/gsap-core';
import ScrollTrigger from 'gsap/ScrollTrigger';

// .patternが存在するか確認
if (document.querySelector('.pattern')) {
  gsap.registerPlugin(ScrollTrigger);
  gsap.config({ nullTargetWarn: false });

  // メディアクエリのマッチング状態を確認
  const mediaQuery = window.matchMedia('(max-width: 1080px)');

  // ScrollTriggerの設定を関数化
  const createScrollTrigger = (offsetY) => {
    ScrollTrigger.create({
      trigger: ".pattern",
      start: `top ${offsetY}px`,
      endTrigger: ".pattern-wrap",
      end: "bottom top",
      markers: false,
      onEnter: () => {
        document.querySelector('.pattern').classList.add('is-fix');
      },
      onLeaveBack: () => {
        document.querySelector('.pattern').classList.remove('is-fix');
      }
    });
  };

  // 初期設定と画面幅変更時の処理
  const handleScreenChange = (e) => {
    // 既存のScrollTriggerをすべて削除
    ScrollTrigger.getAll().forEach(st => st.kill());

    // 画面幅に応じてオフセット値を設定
    const offsetY = e.matches ? 80 : 100;
    createScrollTrigger(offsetY);
  };

  // 初期実行
  handleScreenChange(mediaQuery);

  // 画面幅変更時のリスナー
  mediaQuery.addEventListener('change', handleScreenChange);
}
